import { BUBBLETAP_TEL } from '@repo/constants';

import * as Styled from '../../policy.styled';

export default function PrivacyPolicyKo() {
  return (
    <Styled.MainWrapper>
      <h3>주식회사 버블탭 개인정보처리방침</h3>
      <p>제1조 개인정보처리방침이란?</p>
      <ol>
        ① 개인정보 수집 <br />
        주식회사 버블탭(이하 “회사”)은 이용자들의 개인정보를 중요시합니다. 회사가 이용자에게 제공하는 버블챗, 리워드
        등(이하 “서비스”)을 이용자가 이용함과 동시에 온라인상에서 회사에 제공한 개인정보가 보호 받을 수 있도록 최선을
        다하고 있습니다. 이를 위해 회사는 개인정보보호법, 통신비밀보호법, 전기통신사업법, 정보통신망이용촉진 등에 관한
        법률 등 정보통신서비스 제공자가 준수해야 할 관련 법규상의 개인정보보호 규정을 준수하고 있습니다.
        <br />
        <br />
        서비스 제공을 위한 필요 최소한의 개인정보를 다음 각호에서 수집하고 있습니다. 모든 이용자는 회사가 제공하는
        서비스를 이용할 수 있고, 회원가입을 통해 더욱 다양한 서비스를 제공받을 수 있습니다. 이용자의 개인정보를 수집하는
        경우에는 반드시 사전에 이용자에게 해당 사실을 알리고 동의를 구하도록 하겠습니다. 다음 각호에서 같이 최소한의
        개인정보를 수집하고 있으며, 이용자의 동의 없이 민감 정보를 수집하지 않습니다.
        <br />
        <br /> - 필수정보란: 해당 서비스의 본질적 기능을 수행하기 위한 정보 <br />- 선택정보란: 보다 특화된 서비스를
        제공하기 위해 추가 수집하는 정보
        <br />
        <br />
        <li>
          버블챗, 리워드
          <ol>
            <li>필수: 외부 계정 연동정보(Google, Kakao, Apple 중 이용자가 선택한 정보), Username</li>
            <li>선택: 이메일 주소, 프로필 사진, 소셜 로그인 제공자, 라이터네임</li>
          </ol>
        </li>
        <li>
          계정 정보 찾기
          <ol>
            <li>필수: 소셜 ID, Username, 이메일 주소</li>
          </ol>
        </li>
        <li>
          결제 및 유료 서비스 이용
          <ol>
            <li>필수: 결제일시, 결제 방법, 결제 스토어, 결제 금액, 결제 통화, 결제 IP 구글·애플 결제 ID</li>
          </ol>
        </li>
        <li>
          버블챗 리워드 인센티브 프로그램
          <ol>
            <li>
              필수: 소셜 ID, Username, 이름, 주민등록번호, 예금주명, 은행명, 계좌번호, 매출이 발생한 경우 주민등록번호
            </li>
          </ol>
        </li>
        <li>
          스토리 및 에피소드 등 콘텐츠 (이용약관 제2조 2항 참조) 이용
          <ol>
            <li>필수: 이용 콘텐츠, 이용 일시, 구매 일시</li>
          </ol>
        </li>
        <li>
          마켓플레이스 개인 판매자
          <ol>
            <li>
              필수: 소셜 ID, Username, 이름, 이메일 주소, 휴대전화번호, 미성년판매자의 경우 법정대리인 정보(이름,
              판매자와의 관계, 생년월일, 주소, 전화번호, 이메일 주소, 신분증 사본, 가족관계증명서), 매출이 발생한 경우
              주민등록번호, 계좌정보(예금주, 은행명, 계좌번호)
            </li>
          </ol>
        </li>{' '}
        <li>
          마켓플레이스 개인·법인사업자
          <ol>
            <li>
              필수: 소셜 ID, Username, 이름, 이메일 주소, 대표자명, 전화번호, 사업장 주소, 담당자
              이름/전화번호/이메일주소, 계좌정보(예금주, 은행명, 계좌번호), 제출서류(사업자 등록증, 인감증명서, 대표자명
              통장 사본, 입금계좌신고서, 사용인감증명서)
            </li>
          </ol>
        </li>
        <li>
          공모전 공모
          <ol>
            <li>
              필수: 작가명 또는 닉네임, (만 14세 이상의 경우)전화번호, (15세 미만 관람불가 콘텐츠 등록
              시)본인인증정보(이름, 생년월일, 성별, 이메일, 계좌번호, 내/외국인 정보, 휴대전화번호, 이동통신사 정보,
              암호화된 동일인 식별정보(CI))
            </li>
          </ol>
        </li>
        <li>
          본인 인증
          <ol>
            <li>
              필수: 휴대전화 본인 확인을 위한 이름, 생년월일, 성별, 내/외국인 정보, 휴대전화번호, 이통통신사 정보,
              암호화된 동일인 식별정보(CI), 중복가입확인정보(DI)
            </li>
          </ol>
        </li>
        <li>
          이벤트 응모 및 당첨
          <ol>
            <li>필수: 이름, 주소, 휴대전화번호, 이메일 주소, 주민등록번호</li>
          </ol>
        </li>
        <li>
          고객센터
          <ol>
            <li>필수: 휴대전화번호, 소셜 ID, Username, 이메일</li>
          </ol>
        </li>
      </ol>
      <ol>
        ② 서비스 이용 과정에서 자동으로 생성 또는 수집되는 정보 <br />
        단말기 정보(모델명, 디바이스 아이디, MAC 주소, OS), IP 주소, 쿠키, 접속 로그, 부정이용기록, 서비스 이용기록 등의
        정보가 자동으로 생성되어 수집될 수 있습니다.
        <br />
        <br />
        ③ 개인정보 수집 방법 <br />
        개인정보를 수집하는 경우에는 반드시 사전에 이용자에게 해당 사실을 알리고 동의를 구하고 있으며, 아래와 같은
        방법을 통해 개인정보를 수집합니다.
        <ol>
          <li>회원 가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하는 경우</li>
          <li>회사가 운영하는 소셜 미디어 계정을 해당 소셜 미디어사로부터 제공받은 경우</li>
          <li>제휴 서비스 또는 단체 등으로부터 개인정보를 제공받은 경우</li>
          <li>웹페이지, 메일, 팩스, 전화로 고객센터에서 상담하는 경우</li>
          <li>온·오프라인에서 진행되는 이벤트/행사에서 참여하는 경우</li>
        </ol>
      </ol>
      <p>제2조 개인정보 이용</p>
      이용자의 개인정보를 다음과 같은 목적으로만 이용하며, 목적이 변경될 경우에는 반드시 사전에 이용자에게 동의를
      구하도록 하겠습니다.
      <br />
      <br />
      ① 회원 식별/가입의사 확인, 부정이용 방지, 본인확인 및 인증, 고충처리, 분쟁 조정
      <br />
      ② 활동내역 알림 기능 제공
      <br />
      ③ 인구통계학적 특성과 이용자의 관심, 기호, 성향의 추정을 통한 맞춤형 컨텐츠 추천 및 마케팅에 활용
      <br />
      ④ 신규 서비스 개발 및 이용자 맞춤 서비스 제공, 다양한 서비스 제공, 문의사항 또는 불만처리, 공지사항 전달
      <br />
      ⑤ 유료 또는 리워드 서비스 이용 시, 컨텐츠 등의 전송이나 배송·요금 정산 및 이를 위한 본인인증, 연령인증, 계좌인증
      <br />
      ⑥ 서비스의 원활한 운영에 지장을 주는 행위(계정 도용 및 부정 이용 행위 등 포함)에 대한 방지 및 제재
      <br />
      ⑦ 이벤트/행사 참여 확인, 마케팅 및 광고에 활용
      <br />
      ⑧ 서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시 보호 측면의 서비스 환경 구축, 맞춤형·개인화
      서비스 제공, 서비스 개선에 활용
      <br />
      ⑨ 해킹, 사기 등 관련 사고 조사 및 기타 법령상 의무이행 등에 따른 정당하고 합법적인 수사요청시 자료 제공
      <br />
      <p>제3조 개인정보 보유 및 제공</p>
      ① 이용자의 탈퇴 요청 혹은 개인정보 수집 및 이용목적이 달성된 때까지 보존하며 이후에는 해당 정보를 지체 없이
      파기합니다.
      <br />② 회사의 개인정보처리방침에 따라, 아래와 같은 사유로 회원탈퇴 후에도 명시한 기간 동안 해당 정보를
      보존합니다.
      <br />
      <br />
      <ol>
        <li>
          서비스 이용 관련 개인정보(로그인기록)
          <ol>
            <li>보존 근거: 「통신비밀보호법」</li>
            <li>보존 기간: 3개월</li>
          </ol>
        </li>
        <li>
          반복적 탈퇴/재가입 방지를 위한 정보
          <ol>
            회원 탈퇴한 경우에는 회원 재가입, 임의 해지등을 반복적으로 행함으로써 회사가 제공하는 서비스의 부정이용 및
            이벤트 혜택 등의 이익 등을 불·편법적으로 수취하거나 이 과정에서 명의도용 등의 우려가 있으므로 이러한 행위의
            차단 목적으로 회원 탈퇴 후 1개월 동안 회원정보를 보관합니다.
            <li>보존 근거 : 회사 내부 방침(재가입, 임의해지 등의 부정이용 방지)</li>
            <li>보존 기간: 1개월</li>
          </ol>
        </li>
      </ol>
      <br />
      ③ 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의 거부시 서비스 이용이 불가합니다.
      <br />
      ④ 이용자의 별도 동의가 있는 경우, 법령에 규정된 경우, 이용자 또는 그 법정 대리인이 의사표시를 할 수 없는 상태에
      있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서, 명백히 이용자 또는 제3자의 급박한 생명, 신체, 재산의
      이익을 위하여 필요하다고 인정되는 경우를 제외하고는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 제3자와의
      서비스 연결을 위해 개인정보를 제공할 시, 업체명과 목적, 제공 항목 그리고 개인정보 보유 및 이용기간을 본 약관에
      명시하겠습니다.
      <br />
      <br />
      또한 서비스 제공을 위해 아래와 같은 업무를 위탁하고 있으며, 위탁받은 업체가 관계 법령을 준수하도록 관리·감독하고
      있습니다. 위탁 계약 체결 시 개인정보보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적
      보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시합니다.
      {/* <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>제공받는 업체명</th>
              <th>목적</th>
              <th>제공 항목</th>
              <th>개인정보 보유 및 이용기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>a</td>
              <td>b </td>
              <td>c</td>
              <td>d</td>
            </tr>
            <tr>
              <td>e</td>
              <td>f</td>
              <td>g</td>
              <td>h</td>
            </tr>
          </tbody>
        </table>
      </div> */}
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '50%' }}></col>
            <col style={{ width: '50%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>국내 수탁 업체명</th>
              <th>위탁업무 내용</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>네이버클라우드 주식회사</td>
              <td>서비스 제공 및 분석을 위한 인프라 관리</td>
            </tr>
            <tr>
              <td>(주) 아데나소프트웨어</td>
              <td>
                서비스 개발 및 유지보수
                <br />
                시스템 운영 및 관리
                <br />
                데이터 보관
              </td>
            </tr>
            <tr>
              <td>주식회사 토스페이먼츠</td>
              <td>전자결제 대행</td>
            </tr>
            <tr>
              <td>헥토파이낸셜 주식회사</td>
              <td>전자결제 대행</td>
            </tr>
            <tr>
              <td>주식회사 페이레터</td>
              <td>전자결제 대행</td>
            </tr>
            <tr>
              <td>주식회사 포트원</td>
              <td>본인인증 대행</td>
            </tr>
            <tr>
              <td>네이버 주식회사</td>
              <td>서비스 이용 분석</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '50%' }}></col>
            <col style={{ width: '50%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>국외 수탁 업체명</th>
              <th>위탁업무 내용</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Amazon Web Service, Inc</td>
              <td>서비스 제공 및 분석을 위한 인프라 관리</td>
            </tr>
            <tr>
              <td>
                Alphabet Inc.
                <br />
                Google Payment Korea
              </td>
              <td>
                서비스 제공 및 분석을 위한 인프라 관리
                <br />
                인앱 결제 처리
              </td>
            </tr>
            <tr>
              <td>Meta Platforms Inc.</td>
              <td>서비스 제공 및 분석을 위한 인프라 관리</td>
            </tr>
            <tr>
              <td>Apple Inc.</td>
              <td>
                서비스 제공 및 분석을 위한 인프라 관리
                <br />
                인앱 결제 처리
              </td>
            </tr>
            <tr>
              <td>Anthropic PBC</td>
              <td>서비스 제공 및 분석을 위한 인프라 관리</td>
            </tr>
            <tr>
              <td>OpenAi Inc.</td>
              <td>서비스 제공 및 분석을 위한 인프라 관리</td>
            </tr>
            <tr>
              <td>Razer Merchant Services Sdn. Bhd.</td>
              <td>해외 전자결제 대행</td>
            </tr>

            <tr>
              <td>Airbridge Pte. Ltd.</td>
              <td>앱 어트리뷰션 및 서비스 이용 분석</td>
            </tr>
            <tr>
              <td>Microsoft Corporation</td>
              <td>서비스 이용 분석</td>
            </tr>
            <tr>
              <td>X Corp.</td>
              <td>광고 전환 추적</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>제4조 정보주체의 권리, 의무 및 그 행사방법</p>
      이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.
      <br />
      <br />
      <ol>
        ① 이용자는 회사에 대해 언제든지 개인정보 열람, 오류 등이 있을 경우 정정, 삭제, 처리정지 요구 등의 권리를 행사할
        수 있습니다.
        <br />
        <br />
        ② 이용자는 회사에 대해 가. 항의 권리 행사를 「개인정보 보호법」 시행규칙 별지 제8호 서식에 따라 서면, 전자우편,
        모사전송(Fax) 등을 통해 할 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.
        <br />
        <br />
        ③ 이용자는 ①항의 권리 행사를 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우
        개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출해야 합니다.
        <br />
        <br />
        ④ 회사는 이용자 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나
        정당한 대리인인지를 확인합니다.
        <br />
        <br />
        ⑤ 이용자 혹은 법정대리인이 개인정보의 오류 등에 대한 정정을 요구한 경우에 회사는 정정 또는 삭제를 완료할 때까지
        당해 개인정보를 이용하거나 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 지체 없이 통지하여 정정이
        이루어지도록 하겠습니다.
        <br />
        <br />
        ⑥ 회사는 이용자 혹은 법정대리인에 의해 해지 또는 삭제된 개인정보를 제3조 “개인정보의 보유 및 이용기간"에 명시된
        바에 따라 처리하고, 그 외의 용도로 열람 또는 이용할 수 없도록 조치하겠습니다.
        <br />
        <br />
        ⑦ 이용자의 개인정보 열람 및 처리정지 요구 시 「개인정보 보호법」 제35조 제5항, 제37조 제2항에 의하여 이용자의
        권리가 제한될 수 있습니다.
        <br />
        <br />
        ⑧ 이용자 혹은 법정대리인의 개인정보의 정정 및 삭제 요구 시 다른 법령에서 그 개인정보가 수집 대상으로 명시되어
        있는 경우에는 그 삭제를 요구할 수 없습니다.
        <br />
        <br />⑨ 이용자는 "개인정보 보호법" 등 관계법령을 위반하여 회사가 처리하고 있는 이용자 본인이나 타인의 개인정보
        및 사생활을 침해해서는 안됩니다.
      </ol>
      <p>제5조 개인정보 파기</p>
      개인정보는 수집 및 이용 목적이 달성되면 지체없이 재생이 불가능한 방법으로 파기합니다. 또한, ‘개인정보
      유효기간제’에 따라 1년의 기간 동안 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관하고 있으며, 분리
      보관된 개인정보는 4년간 보관 후 지체 없이 파기합니다.
      <br />
      <br />이 외에 법령에 따라 일정 기간 보관해야 하는 개인정보 및 해당 법령은 아래 표와 같습니다.
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>보관 정보</th>
              <th>보존 이유</th>
              <th>보존 기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                계약 또는 청약 철회 등에 <br />
                관한 기록
              </td>
              <td>
                전자상거래 등에서의 <br /> 소비자보호에 관한 법률
              </td>
              <td>5년</td>
            </tr>
            <tr>
              <td>
                대금결제 및 재화 등의
                <br /> 공급에 관한 기록
              </td>
              <td>
                전자상거래 등에서의 <br />
                소비자보호에 관한 법률
              </td>
              <td>5년</td>
            </tr>
            <tr>
              <td>
                소비자 불만 또는 분쟁처리에
                <br /> 관한 기록
              </td>
              <td>
                전자상거래 등에서의 <br />
                소비자보호에 관한 법률
              </td>
              <td>3년</td>
            </tr>
            <tr>
              <td>표시/광고에 관한 기록</td>
              <td>
                전자상거래 등에서의 <br />
                소비자보호에 관한 법률
              </td>
              <td>6개월</td>
            </tr>
            <tr>
              <td>
                세법이 규정하는 모든 거래에 <br />
                관한 장부 및 증빙서류
              </td>
              <td>국세기본법</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>서비스 이용 관련 로그인 기록</td>
              <td>통신비밀보호법</td>
              <td>3개월</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>제 6조 기타</p>
      ① 언제든 자신의 개인정보를 조회하거나 수정할 수 있으며, 수집·이용에 대한 동의 철회 또는 가입 해지를 요청할 수도
      있습니다.
      <br />
      <br />
      ② 만 14세 미만 아동의 개인정보는 법정대리인의 요구가 있는 경우, 법령 상의 권리(아동의 개인정보에 대한 열람,
      정정·삭제, 개인정보 처리정지 요구권)를 보장합니다.
      <br />
      <br />
      <ol>
        ③ 인터넷 서비스를 통하여 고객의 정보를 저장하고 수시로 찾아내는 쿠키(cookie)를 설치/운용하고 있습니다.
        <li>
          사용목적
          <ol>
            <li>
              쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자의
              하드 디스크에 저장됩니다. 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고
              수시로 불러오는 이 쿠키를 사용합니다. 또한 이용자의 웹사이트 방문 기록, 이용 형태를 통해서 최적화된 광고
              등 맞춤형 정보를 제공하기 위해 활용됩니다.
            </li>
          </ol>
        </li>
        <li>
          쿠키 수집 거부
          <ol>
            <li>
              쿠키에는 이름, 휴대전화번호 등 개인을 식별하는 정보를 저장하지 않으며, 이용자는 쿠키 설치에 대한 선택권을
              가지고 있습니다. 제6조 3항 3번의 방법으로 쿠키 설치를 거부할 수 있으나, 이를 거부할 경우 웹 사용이
              불편해지며, 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.
            </li>
          </ol>
        </li>
        <li>
          쿠키 수집 거부 방법
          <ol>
            <li>Internet Explorer: [설정] → [인터넷 옵션] → [개인정보] → [고급]</li>
            <li>Chrome: [설정] → [개인정보 및 보안] → [사이트 설정] → [쿠키 및 기타 사이트 데이터]</li>
            <li>Edge: [설정] → [쿠키 및 사이트 권한] → [쿠키 및 사이트 권한]</li>
            <li>Safari: [환경설정] → [개인정보] → [쿠키 및 웹사이트 데이터 수준]</li>
          </ol>
        </li>
      </ol>
      <ol>
        ④ 회사는 이용자의 ADID/IDFA를 수집할 수 있습니다.
        <br />
        <br />
        <li>
          수집 목적
          <ol>
            <li>
              ADID/IDFA란 모바일 앱 이용자의 광고 식별값으로서 사용자의 맞춤 서비스 제공이나 더 나은 환경의 광고를
              제공하기 위해 측정 및 수집하고 있습니다.
            </li>
          </ol>
        </li>
        <li>
          거부 방법
          <ol>
            <li>Android: [설정] → [구글(구글설정)] → [광고] → [광고 맞춤설정]</li>
            <li>iOS: [설정] → [개인정보 보호] → [광고] → [광고 추적 제한] </li>
          </ol>
        </li>
      </ol>
      <ol>
        ⑤ 회사는 이용자의 소중한 개인정보 보호를 위해 다음의 노력을 하고 있습니다.
        <li>
          회사는 이용자의 개인정보를 암호화된 통신구간을 이용하여 전송하고, 비밀번호 등 중요정보는 암호화하여 보관하고
          있습니다.
        </li>
        <li>
          회사는 해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해 외부로부터
          접근이 통제된 구역에 시스템을 설치하고 있습니다. 해커 등의 침입을 탐지하고 차단할 수 있는 시스템을 설치하여
          24시간 감시하고 있으며, 백신 프로그램을 설치하여 시스템이 최신 악성코드나 바이러스에 감염되지 않도록 노력하고
          있습니다. 또한 새로운 해킹/보안 기술에 대해 지속적으로 연구하여 서비스에 적용하고 있습니다.
        </li>
        <li>
          회사는 개인정보를 취급하는 직원을 최소화합니다. 또한 개인정보를 보관하는 데이터베이스 시스템과 개인정보를
          처리하는 시스템에 대한 비밀번호의 생성과 변경, 그리고 접근할 수 있는 권한에 대한 체계적인 기준을 마련하고
          지속적인 감사를 실시하고 있습니다.
        </li>
        <li>
          개인정보를 취급하는 모든 임직원들을 대상으로 개인정보보호 의무와 보안에 대한 정기적인 교육을 실시하고
          있습니다.
        </li>
        <li>
          회사는 개인정보 보호를 위해 정기적인 자체 감사 실시하고 있습니다. 또한 개인정보처리시스템에 접속한 기록을
          보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.
        </li>
      </ol>
      ⑥ 개인정보보호와 관련해서 궁금하신 사항은 아래 연락처로 문의해 주시기 바랍니다.
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>개인정보보호책임자</th>
              <th>담당부서</th>
              <th>문의</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>박영은</td>
              <td>버블탭팀</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      또한 개인정보가 침해되어 이에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하셔서 도움을 받으실 수
      있습니다.
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>구분</th>
              <th>연락처</th>
              <th>사이트 주소</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>개인정보침해 신고센터</td>
              <td>(국번없이)118</td>
              <td>https://privacy.kisa.or.kr</td>
            </tr>
            <tr>
              <td>대검찰청 사이버수사과</td>
              <td>(국번없이)1301</td>
              <td>https://spo.go.kr</td>
            </tr>
            <tr>
              <td>경찰청 사이버안전국</td>
              <td>(국번없이)182</td>
              <td>https://ecrm.police.go.kr</td>
            </tr>
            <tr>
              <td>개인정보분쟁조정위원회</td>
              <td>(국번없이)1833-6972</td>
              <td>https://www.kopico.go.kr</td>
            </tr>
          </tbody>
        </table>
      </div>
      ⑦ 개인정보처리방침이 변경되는 경우 <br />
      <br />
      법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인정보처리방침을 수정할 수 있습니다. 개인정보처리방침이
      변경되는 경우 변경 사항을 게시하며, 변경된 개인정보처리방침은 변경 사항을 게시한 날로부터 7일 후 효력이
      발생합니다. 다만, 수집하는 개인정보의 항목, 이용목적의 변경 등과 같이 이용자 권리의 중대한 변경이 발생할 때에는
      최소 30일 전에 미리 알려드리겠습니다.
      <br />
      <br />
      {/* 공고일자: 2022년 5월 xx일 <br />
      시행일자: 2022년 5월 xx일 */}
    </Styled.MainWrapper>
  );
}
